
















import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { GridType, SelectionType, TileType } from '@/data/enums'

import ImageTile from './ui/ImageTile.vue'
import Tile from '@/store/models/Tile'
import TilePayload from '@/store/models/TilePayload'

@Component({
  components: {
    ImageTile
  }
})
export default class SelectionGrid extends Vue {
  @Prop({ default: TileType.Default }) public tileType!: TileType
  @Prop() public type!: SelectionType

  private gridType: GridType = GridType.Two

  @Emit('selectionChange')
  public emitSelectionChange (tile: Tile) { /**/ }

  @Emit('onValueChanged')
  public doValueChanged (payload: TilePayload) { /**/ }

  public onSelectionChange (tile: Tile) {
    const tilePayload = new TilePayload(tile, this.type)
    this.$store.dispatch('matrix/changeSelection', tilePayload)
      .catch((err) => console.error(err))
  }

  private get items () {
    const getSelectionsByType = this.$store.getters['matrix/getSelectionsByType']
    const items = getSelectionsByType(this.type)
    this.changeGridSize(items)

    return items
  }

  private changeGridSize (value: Tile[]) {
    if (value.length < 6) {
      this.gridType = GridType.Two
    } else if (value.length > 2 && value.length < 9) {
      this.gridType = GridType.Six
    } else if (value.length > 6 && value.length < 12) {
      this.gridType = GridType.Nine
    } else if (value.length > 9) {
      this.gridType = GridType.Twelve
    }
  }
}
